import {
  withLabelsContext,
  withApiContext,
  withUserContext,
  withWindowContext,
} from "context";
import React, { PureComponent } from "react";
import { MainContainer } from "pages/Main";
import { ResponsiveTabs, Select } from "components";
import FormField from "components/FormField";
import { withRouter } from "react-router-dom";
import FormDateRangePicker from "components/FormDateRangePicker/FormDateRangePicker";
import { Breadcrumb, PageTitle, Toolbar, Button } from "components";
import * as messages from "messages";
import Dashboard from "./Dashboard";
import MyClasses from "pages/MyClasses/MyClasses";
import TraineeProgressTable from "./TraineeProgressTable";
import ProgressForm from "pages/Progress/Form";
import * as config from 'config';
import { Link } from "react-router-dom/cjs/react-router-dom";
import TableSubjects from "pages/MyClasses/MyClasses/TableSubjects/TableSubjects";

// Material UI imports
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Grid,
  Chip,
  Divider,
  Container
} from "@mui/material";

class Mycourseform extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      coursePubName: "",
      className: "",
      classNameClassWise: "",
      members: [],
      fromDate: "",
      endDate: "",
      redirect: false,
      classId: "",
      classSelected: false,
      studentNames: [],
      attendanceData: [],
      showTable: false,
      studentDetails: [],
      courseData: null,
      isLoading: false,
    };
  }

  componentDidMount = () => {
    console.log(this.props)
    this.setState({ showTable: false });
    
    // Check if coming from MyClasses with course data
    if (this.props.location.state?.fromMyClasses && this.props.location.state?.courseData) {
      this.setState({ 
        isLoading: true 
      }, () => {
        // Simulate a small delay to show loading state
        setTimeout(() => {
          this.setState({ 
            showTable: true,
            courseData: this.props.location.state.courseData,
            isLoading: false
          });
        }, 500);
      });
    } else {
      // If accessed directly, show the default view
      this.setState({ 
        showTable: true,
        courseData: null
      });
    }
  };

  handleRedirect = () => {
    this.setState({ redirect: true });
  };

  
  
  
  renderForm = () => {
    return (
      <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden', mx: 2 }}>
        <div className="mycourse-tabs-container">
          <ResponsiveTabs
            fromViewerForm
            onChange={() => {
              this.setState({
                showTable: false,
                fromDate: "",
                endDate: "",
                studentNames: [],
                className: "",
                coursePubName: "",
              });
            }}
            unmountOnExit={this.props.unmountOnExit ?? true}
            tight
            items={[
              {
                key: "1",
                label: (
                  <Box sx={{ px: 2, py: 1 }}>
                    <div className="tab-label">
                      <i className="fas fa-users me-2"></i>
                      Trainee Progress
                    </div>
                  </Box>
                ),
                children: (
                  <div className="tab-content-wrapper">
                    {this.renderClassWiseForm()}
                  </div>
                ),
              },
              {
                key: "2",
                label: (
                  <Box sx={{ px: 2, py: 1 }}>
                    <div className="tab-label">
                      <i className="fas fa-brain me-2"></i>
                      AI Course Insight
                    </div>
                  </Box>
                ),
                children: (
                  <div className="tab-content-wrapper">
                    {this.renderCourseWiseForm()}
                  </div>
                ),
              },
              {
                key: "3",
                label: (
                  <Box sx={{ px: 2, py: 1 }}>
                    <div className="tab-label">
                      <i className="fas fa-chart-line me-2"></i>
                      Teacher Analytics
                    </div>
                  </Box>
                ),
                children: (
                  <div className="tab-content-wrapper">
                    {this.renderStudentWiseForm()}
                  </div>
                ),
              },
            ]}
          />
        </div>
      </Paper>
    );
  };
  renderCourseWiseForm = () => {
    return (
      <Dashboard/>
    );
  };

 

  renderClassWiseForm = () => {
    return (
      <Box sx={{ px: 3 }}>
        <div className="tab-content-container">
          <div className="tab-content">
            <TraineeProgressTable data={this.props.location.state?.courseData}/>
          </div>
        </div>
      </Box>
    );
  };


  renderStudentWiseForm = (val) => {
    // Hardcoded URL for the iframe
    const hardcodedUrl = "https://aai-llms-analytics.e42.ai/ui"; // Replace with your desired URL

    return (
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          
          <Box sx={{ position: 'relative' }}>
            <iframe
              src={hardcodedUrl}
              title="Teacher Analytics Dashboard"
              width="100%"
              height="700px"
              frameBorder="0"
              allowFullScreen
              style={{
                border: 'none',
                borderRadius: '0 0 8px 8px'
              }}
              onError={() => {
                alert('Error loading the analytics dashboard. Please check your internet connection.');
              }}
            />
          </Box>
        </Paper>
      </Container>
    );
  };

  render = () => {
    const { courseData, isLoading } = this.state;
    
    const breadcrumbList = [
      {
        title: courseData ? "Course Details" : "MyCourse",
        current: !courseData,
      }
    ];

    // Add course name to breadcrumb if coming from MyClasses
    if (courseData) {
      breadcrumbList.push({
        title: courseData.coursepub_name,
        current: true,
      });
    }

    if (isLoading) {
      return (
        <MainContainer>
          <Breadcrumb list={breadcrumbList} />
          <div className="page-header-container">
            <PageTitle>Loading Course Details...</PageTitle>
          </div>
          <div className="loading-container">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p className="loading-text">Loading course information...</p>
          </div>
        </MainContainer>
      );
    }

    return (
      <MainContainer>
        <Breadcrumb list={breadcrumbList} />
        
        {/* Enhanced Page Header Bar */}
        <Paper 
          elevation={2} 
          sx={{ 
            mb: 3, 
            borderRadius: 2,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            overflow: 'hidden'
          }}
        >
          <Box sx={{ p: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              {courseData ? `${courseData.coursepub_name} - Course Details` : "My Courses"}
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9, mb: 2 }}>
              {courseData ? "Comprehensive course management and analytics" : "Manage and monitor your courses"}
            </Typography>
            
            {courseData && (
              <Box sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ 
                        bgcolor: 'rgba(255,255,255,0.2)', 
                        width: 40, 
                        height: 40 
                      }}>
                        <span role="img" aria-label="graduation" style={{ fontSize: '1.2rem' }}>🎓</span>
                      </Avatar>
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          Class Name
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {courseData.classname}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={12} sm={6} md={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ 
                        bgcolor: 'rgba(255,255,255,0.2)', 
                        width: 40, 
                        height: 40 
                      }}>
                        <span role="img" aria-label="book" style={{ fontSize: '1.2rem' }}>📚</span>
                      </Avatar>
                      <Box>
                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                          Curriculum
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {courseData.currname}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  
                  
                </Grid>
              </Box>
            )}
          </Box>
        </Paper>
        
        <div className="page-content-wrapper">
          {this.renderForm()}
        </div>
      </MainContainer>
    );
  };
}
export default withApiContext(
  withLabelsContext(withUserContext(withRouter(withWindowContext(Mycourseform))))
);
